import React from 'react';
import { Box, Card, CardBody, Heading, Spinner, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';

const TopSpenderCard = ({
  topSpendersLoading,
  topSpenders,
  surfaceCard,
  DASHBOARD_TYPE,
  formatCurrency,
  handleShowCustomerDetail,
}) => (
  <Card {...surfaceCard} h="100%">
    <CardBody>
      <Heading fontSize={DASHBOARD_TYPE.chartTableTitle} fontWeight="600" mb={4} color="rgba(0, 0, 0, 0.78)" borderBottom="1px solid rgba(0,0,0,0.08)" pb={2}>
        Top 10 Spender
      </Heading>
      {topSpendersLoading ? (
        <Box textAlign="center" py={8}><Spinner /></Box>
      ) : topSpenders && topSpenders.length > 0 ? (
        <TableContainer maxH="420px" overflowY="auto" borderRadius="12px" border="1px solid rgba(15,23,42,0.08)">
          <Table size="sm" variant="simple">
            <Thead position="sticky" top={0} bg="#F8FAFC" zIndex={1}>
              <Tr>
                <Th fontSize={DASHBOARD_TYPE.tableHeader} letterSpacing="0.08em" textTransform="uppercase">Rank</Th>
                <Th fontSize={DASHBOARD_TYPE.tableHeader} letterSpacing="0.08em" textTransform="uppercase">Customer</Th>
                <Th fontSize={DASHBOARD_TYPE.tableHeader} letterSpacing="0.08em" textTransform="uppercase" isNumeric>Total Spent</Th>
                <Th fontSize={DASHBOARD_TYPE.tableHeader} letterSpacing="0.08em" textTransform="uppercase" isNumeric>Txns</Th>
              </Tr>
            </Thead>
            <Tbody>
              {topSpenders.map((spender) => (
                <Tr key={spender.rank} _hover={{ bg: 'rgba(0,122,255,0.06)' }}>
                  <Td fontWeight="bold" color="blue.600" fontSize={DASHBOARD_TYPE.dataLabel}>#{spender.rank}</Td>
                  <Td fontSize={DASHBOARD_TYPE.dataLabel}>
                    <Text as="button" color="blue.600" fontWeight="semibold" _hover={{ textDecoration: 'underline', color: 'blue.700' }} onClick={() => handleShowCustomerDetail(spender.customerName)} cursor="pointer">
                      {spender.customerName}
                    </Text>
                  </Td>
                  <Td isNumeric fontWeight="semibold" color="green.600" fontSize={DASHBOARD_TYPE.dataLabel} sx={{ fontVariantNumeric: 'tabular-nums' }}>
                    {formatCurrency(spender.totalSpent)}
                  </Td>
                  <Td isNumeric fontSize={DASHBOARD_TYPE.dataLabel} sx={{ fontVariantNumeric: 'tabular-nums' }}>{spender.transactionCount}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      ) : (
        <Text color="gray.500" textAlign="center" py={8}>No data available</Text>
      )}
    </CardBody>
  </Card>
);

export default TopSpenderCard;
